import { engineComponent, NumberUtils, StringUtils } from "neo-common";
import { ILayoutElement } from "./ILayoutElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { LayoutManager } from "../Managers/LayoutManager";
import { StageController } from "../Components/StageController";
import { ImageElement, ImageElementAttributes } from "../Components/Elements/Graphics/ImageElement";

@engineComponent(ComponentTypes.DisplayObject)
export class LayoutImageElement extends ImageElement implements ILayoutElement {
    protected verticalAlign: string;

    protected skipAlign: boolean;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor(texture?: PIXI.Texture) {
        super(texture);
        this.verticalAlign = LayoutImageElementAttributes.V_ALIGN_OPTIONS.TOP;
        LayoutManager.addLayoutElement(this);
    }

    updateByNode(node: Element): ImageElement {
        super.updateByNode(node);

        if (node.hasAttribute(LayoutImageElementAttributes.V_ALIGN)) {
            this.verticalAlign = node.getAttribute(LayoutImageElementAttributes.V_ALIGN);
        }

        if (node.hasAttribute(LayoutImageElementAttributes.SKIP_ALIGN)) {
            this.skipAlign = StringUtils.parseBoolean(node.getAttribute(LayoutImageElementAttributes.SKIP_ALIGN));
        }

        this.updatePosition();
        return this;
    }

    onLayoutChange(isPortrait: boolean): void {
        this.updatePosition();
    }

    updatePosition(): void {
        this.updateVerticalPosition();
    }

    updateVerticalPosition(): void {
        if (this.skipAlign) {
            return;
        }

        let y = 0;
        let height = this.getBounds().height;
        let screenHeight = StageController.Renderer.screen.height;

        switch (this.verticalAlign) {
            case LayoutImageElementAttributes.V_ALIGN_OPTIONS.TOP:
                break;
            case LayoutImageElementAttributes.V_ALIGN_OPTIONS.CENTER:
                if (screenHeight < height) {
                    y = parseInt(NumberUtils.devide(screenHeight - height, 2));
                }
                break;
            case LayoutImageElementAttributes.V_ALIGN_OPTIONS.BOTTOM:
                y = screenHeight - height;
                break;
        }

        this.y = y;
    }

    clone(): LayoutImageElement {
        let element: LayoutImageElement = new LayoutImageElement();
        element.removeChildren();

        element.position.x = this.position.x;
        element.position.y = this.position.y;
        element.pivot.x = this.pivot.x;
        element.pivot.y = this.pivot.y;
        element.scale.x = this.scale.x;
        element.scale.y = this.scale.y;
        element.rotation = this.rotation;
        element.visible = this.visible;
        element.alpha = this.alpha;
        element.anchor = this.anchor;
        element.tint = this.tint;
        element.blendMode = this.blendMode;
        element.name = this.name;

        element.verticalAlign = this.verticalAlign;

        if (this.texture != null) {
            element.texture = this.texture;
        }

        if (this.maskSprite != null) {
            let elementMask = new PIXI.Sprite((<PIXI.Sprite>this.maskSprite).texture);
            elementMask.position.x = this.maskSprite.position.x;
            elementMask.position.y = this.maskSprite.position.y;

            element.maskSprite = elementMask;
            element.addChild(elementMask);
            element.mask = elementMask;
        } else if (this.maskGraphics != null) {
        }

        element.markAsCloned(); // must be called last before return!

        return element;
    }
}

export const LayoutImageElementAttributes = {
    V_ALIGN: "VAlign",
    V_ALIGN_OPTIONS: {
        TOP: "top",
        CENTER: "center",
        BOTTOM: "bottom",
    },
    SKIP_ALIGN: "SkipAlign",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/LayoutImageElement.ts
 **/